import React from 'react'; // eslint-disable-line

import { Grid, withStyles } from '@material-ui/core';
import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { Section } from '../../../../../../controls/section';
import { FullWidthDatePicker, FullWidthTextField } from '../../../../../../forms';
import { requiredValidator } from '../../../../../../forms/validations';
import { State } from '../../../../../../redux/root-reducer';
import styles, { StyledComponent } from '../../../../../../styles/styles';

interface OwnProps {}

interface StateProps {}

interface DispatchProps {}

type Props = OwnProps & StateProps & DispatchProps & StyledComponent;

const postUnderwritingChangeForm: React.FunctionComponent<Props> = () => {
    return (
        <Section title="Post Underwriting Change">
            <Grid item xs={3}>
                <FullWidthDatePicker
                    name="date"
                    label="Date"
                    validate={requiredValidator}
                    disableFuture
                />
            </Grid>
            <Grid item xs={9}>
                <FullWidthTextField name="details" label="Details" validate={requiredValidator} />
            </Grid>
        </Section>
    );
};

const mapStateToProps: MapStateToProps<StateProps, OwnProps, State> = () => ({});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {};

export const PostUnderwritingChangeForm = connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(postUnderwritingChangeForm));
